export default __webpack_public_path__ + "fonts/AreaJPNormal-Regular.b0b4c77d9b7181be5c0a4e3219fe5f5d.woff2";